import { gql } from "@apollo/client";

export const UPDATE_SADDLE_VARIANT = gql`
mutation updateSaddleFitVariant($input: UpdateSaddleFitVariantInput!) {
    updateSaddleFitVariant(input: $input) {
      brandName
      createdAt
      description
      discipline
      discount
      gallery
      newOrUsed
      photo
      pk
      price
      productTitle
      quantity
      saddlefitSku
      scannedFiles
      score
      size
      sk
      status
      type
      updatedAt
      userId
      variantId
      measurements {
        barAngle
        gulletHeight
        gulletWidth
      }
      manufacturerMeasurements {
        barAngle
        gulletHeight
        gulletWidth
      }
    }
  }`